var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPontem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3008_16032)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3008_16032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.27903 0 0 6.27317 0 13.9869C0 19.5312 3.2458 24.3351 7.93927 26.5964V26.6079H7.96225C9.78908 27.486 11.84 27.9796 14 27.9796C21.7209 27.9796 28 21.7064 28 13.9927C28 6.27317 21.7209 0 14 0ZM14 1.14788C21.0833 1.14788 26.8511 6.91025 26.8511 13.9869C26.8511 16.0187 26.3743 17.9472 25.5297 19.6575C23.6799 18.7621 21.8013 18.0964 19.9056 17.6429V6.93321C19.9056 6.56015 19.6127 6.26169 19.2449 6.26169H16.8896H10.9553H8.59992C8.238 6.26169 7.93927 6.56015 7.93927 6.93321V17.6947C6.10095 18.148 4.27411 18.8023 2.476 19.6632C1.62577 17.9472 1.14895 16.0244 1.14895 13.9869C1.14895 6.91025 6.91671 1.14788 14 1.14788ZM3.21707 20.9545C4.73944 20.2028 6.31924 19.6231 7.94501 19.2213V25.3051C6.02052 24.2777 4.39475 22.774 3.21707 20.9545ZM10.9553 26.4587V12.1274C10.9553 10.4687 12.3168 9.09697 13.9425 9.09697C15.5683 9.09697 16.8896 10.44 16.8896 12.0929C16.8896 12.1044 16.8839 12.1159 16.8839 12.1274H16.8896V17.1149C15.5051 16.9543 14.1149 16.9025 12.7247 16.9772L11.5815 18.6359C13.3623 18.4867 15.0972 18.4981 16.8092 18.6933C16.8264 18.6933 16.8379 18.6933 16.8552 18.6991C16.8667 18.6991 16.8781 18.6991 16.8953 18.7048C17.1941 18.7392 18.2799 18.8769 19.2737 19.1237L16.8953 19.9329V26.5047C15.9647 26.7169 14.9996 26.8375 14.0115 26.8375C12.9487 26.826 11.9319 26.694 10.9553 26.4587ZM19.8999 25.3855V19.25C21.5199 19.6575 23.1227 20.2544 24.7312 21.0349C23.5248 22.8659 21.8588 24.3696 19.8999 25.3855Z",
    fill: "url(#paint0_linear_3008_16032)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3008_16032",
    x1: 0.4375,
    y1: 13.9899,
    x2: 28.4383,
    y2: 13.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0858,
    stopColor: "#8D29C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2383,
    stopColor: "#942BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4667,
    stopColor: "#A92FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7413,
    stopColor: "#CA3793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03F77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3008_16032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3008_16032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPontem);
export default __webpack_public_path__ + "static/media/pontem.0cf8dd6981ee6b551938974a6774381b.svg";
export { ForwardRef as ReactComponent };